import { render, staticRenderFns } from "./rwsaudara.vue?vue&type=template&id=0ec5e930"
import script from "./rwsaudara.vue?vue&type=script&lang=js"
export * from "./rwsaudara.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports